// import $ from 'jquery';

import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/modal';

import './frontend/accessibility';
import './frontend/alert';
import './frontend/cookie-consent';
import './frontend/mobile-menu';
import './frontend/navbar-scroll';
import './frontend/modal';
import './frontend/navbar';
import './frontend/scroll-to-hash';
import './frontend/select';

import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();
